import {useNavigate} from "react-router-dom";
import Logo from "../../Assets/images/logo/connectcaremintgreen.png";
import Illustration from "../../Assets/images/illustrations/medicine.svg";

export const Error404 = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="grid min-h-screen grid-cols-1 grid-rows-[1fr,auto,1fr] bg-white lg:grid-cols-[max(50%,36rem),1fr]">
                <header className="mx-auto w-full max-w-7xl px-6 pt-6 sm:pt-10 lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:px-8">
                    <a href="#">
                        <img
                            className="h-10 w-auto sm:h-12"
                            src={Logo}
                            alt=""
                        />
                    </a>
                </header>
                <main className="mx-auto w-full max-w-7xl px-6 py-24 sm:py-32 lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:px-8">
                    <div className="max-w-lg">
                        <p className="text-base font-semibold leading-8 text-primary">404</p>
                        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Page not found</h1>
                        <p className="mt-6 text-base leading-7 text-gray-600">
                            Sorry, we couldn’t find the page you’re looking for.
                        </p>
                        <div className="mt-10">
                            <a href="#" onClick={() => navigate(-1)} className="text-sm font-semibold leading-7 text-primary">
                                <span aria-hidden="true">&larr;</span> Go back
                            </a>
                        </div>
                    </div>
                </main>
                <div className="hidden lg:relative lg:col-start-2 lg:row-start-1 lg:row-end-4 lg:block">
                    <div className={'w-full p-3 h-full'}>
                        <div
                            className={'relative rounded-lg p-4 flex-col justify-center hidden md:flex h-full w-full'}>
                            <div
                                className={'absolute top-0 left-0 bg-gradient-to-b opacity-20 from-primary to-secondary w-full h-full rounded-lg'}>&nbsp;</div>
                            <img src={Illustration} alt={'Illustration of a doctor'} className={'m-auto max-h-[50%]'}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}